import { render, staticRenderFns } from "./DaoView.vue?vue&type=template&id=07821cfc&scoped=true&"
import script from "./DaoView.vue?vue&type=script&lang=js&"
export * from "./DaoView.vue?vue&type=script&lang=js&"
import style0 from "./DaoView.vue?vue&type=style&index=0&id=07821cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07821cfc",
  null
  
)

export default component.exports